
export default {
  mappedLocations: [],
  radiusMarkers: [],
  locations: [],
  well: [],
  allLocations: [],
  locationType: 'state',
  zoomLevel: 6.3,
  lastLocationType: null,
  searchList: [],
  detailDialog: false,
  detail: null,
  loading: false,
  loaded: false,
};
